<ng-container *ngIf="isProductDetailPopupVisible$ | async as isProductDetailPopupVisible">
  <ng-container  *ngIf="productDetail$ | async as productDetail">
    <div class="support">
      <article class="md:shadow-5 md:border-round" @fadeInOut>
        <header class="relative
                md:border-round-top">
          <div class="absolute flex right-0">
            <button class="closed--button" (click)="closeDetail()">X</button>
          </div>
          <img  class="w-full h-full"
            *ngIf="imageUrl$ | async as url; else noImagePath"
            [ngSrc]="url"
            fill
            [placeholder]="placeholder"
            alt="image du produit">
            <!-- Si pas de nom de l'image-->
            <ng-template #noImagePath>
              <img class="max-h-10rem no--img"
              [src]="placeholder"
              alt="image du produit">
            </ng-template>
        </header>
        <main>
          <div class="p-2 flex flex-column w-full justify-content-center align-items-center">
            <p class="font-semibold text-lg"> {{ productDetail.productName }}</p>
            <p class="p-1 uppercase text-sm"> {{ productDetail.productCatgegoryLabel }}</p>
          </div>
          <!-- Produit en mode activation-->
          <ng-container *ngIf="areProductInActivateMode$ | async; else update">
            <div [formGroup]="updateProductFg" class="w-full p-5">
              <div class="relative">
                <!-- Overlay-->
                <div class="surface-ground absolute top-0 bottom-0 w-full z-2"></div>
                <!--prix-->
                <div class="flex w-full flex-column
                            md:flex-row md:justify-content-between">
                  <!--productPurchasePrice-->
                  <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
                    <label class="text-sm text-color-secondary" for="productPurchasePrice"> Prix d'achat</label>
                    <input formControlName="productPurchasePrice" pInputText type="number" placeholder="Prix d'achat">
                  </div>

                  <!--productSoldPrice-->
                  <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
                    <label class="text-sm text-color-secondary" for="productSoldPrice"> Prix de vente</label>
                    <input  pInputText formControlName="productSoldPrice" id="productSoldPrice" type="number" placeholder="Prix de vente">
                  </div>
                </div>

                <!--Dates-->
                <div class="flex w-full flex-column
                          md:flex-row md:justify-content-between">
                  <!--Date d'achat-->
                  <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
                    <label class="text-sm text-color-secondary" for="productBuyDate"> Date d'achat</label>
                    <p-calendar formControlName="productBuyDate" dateFormat="dd/mm/yy"  appendTo="body"></p-calendar>

                  </div>

                  <!--Date de vente-->
                  <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
                    <label class="text-sm text-color-secondary" for="productSoldDate"> Date de vente</label>
                    <p-calendar formControlName="productSoldDate" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
                    <div class="flex items-center gap-1 pt-2">
                      <p-checkbox formControlName="productStatus" binary="true" inputId="ips" />
                      <label for="ips" class="ml-2">Le produit est vendu</label>
                    </div>
                  </div>
                </div>
              </div>

              <!--Boutton-->
              <div class="flex flex-column w-full
                          md:flex-row">
                <p-button (onClick)="activateProduct()" severity="success" type="button" class="full--width--button m-1" label="Réactiver le produit"/>
              </div>
            </div>
          </ng-container>

          <!-- Produite en mode mise a jour-->
          <ng-template #update>
            <form [formGroup]="updateProductFg" class="w-full p-5">
              <!--prix-->
              <div class="flex w-full flex-column
                          md:flex-row md:justify-content-between">
                <!--productPurchasePrice-->
                <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
                  <label class="text-sm text-color-secondary" for="productPurchasePrice"> Prix d'achat</label>
                  <input pInputText formControlName="productPurchasePrice" id="productPurchasePrice" type="number" placeholder="Prix d'achat">

                  <!--Message d'erreur-->
                  <div class="min-h-0">
                    <ng-container *ngIf="updateProductFg.get('productPurchasePrice')?.invalid && (updateProductFg.get('productPurchasePrice')?.dirty || updateProductFg.get('productPurchasePrice')?.touched)">

                      <!-- Info manquante-->
                      <p-message *ngIf="updateProductFg.get('productPurchasePrice')?.hasError('required')"
                        class="p-message" severity="error" text="Le prix d'achat est obligatoire">
                      </p-message>

                      <!-- Format erroné -->
                      <p-message *ngIf="updateProductFg.get('productPurchasePrice')?.hasError('validateNumber')"
                        class="p-message" severity="error" text="Le prix d'achat à un format invalide">
                      </p-message>
                    </ng-container>
                  </div>
                </div>

                <!--productSoldPrice-->
                <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
                  <label class="text-sm text-color-secondary" for="productSoldPrice"> Prix de vente</label>
                  <input pInputText formControlName="productSoldPrice" id="productSoldPrice" type="number" placeholder="Prix de vente">

                  <!--Message d'erreur-->
                  <div class="min-h-0">
                    <ng-container *ngIf="updateProductFg.get('productSoldPrice')?.invalid && (updateProductFg.get('productSoldPrice')?.dirty || updateProductFg.get('productSoldPrice')?.touched)">

                      <!-- Format erroné -->
                      <p-message *ngIf="updateProductFg.get('productSoldPrice')?.hasError('validateNumber')"
                        class="p-message" severity="error" text="Le prix de vente à un format invalide">
                      </p-message>
                    </ng-container>
                  </div>
                </div>
              </div>

              <!--Dates-->
              <div class="flex w-full flex-column
                        md:flex-row md:justify-content-between">
                <!--Date d'achat-->
                <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
                  <label class="text-sm text-color-secondary" for="productBuyDate"> Date d'achat</label>
                  <p-calendar formControlName="productBuyDate" dateFormat="dd/mm/yy"  appendTo="body"></p-calendar>

                  <!--Message d'erreur-->
                  <div class="min-h-0">
                    <ng-container *ngIf="updateProductFg.get('productBuyDate')?.invalid && (updateProductFg.get('productBuyDate')?.dirty || updateProductFg.get('productBuyDate')?.touched)">

                      <!-- Info manquante-->
                      <p-message *ngIf="updateProductFg.get('productBuyDate')?.hasError('required')"
                        class="p-message" severity="error" text="Le prix d'achat est obligatoire">
                      </p-message>

                      <!-- Format erroné -->
                      <p-message *ngIf="updateProductFg.get('productBuyDate')?.hasError('validateNumber')"
                        class="p-message" severity="error" text="Le prix d'achat à un format invalide">
                      </p-message>
                    </ng-container>
                  </div>
                </div>

                <!--Date de vente-->
                <div class="text-sm text-color-secondary" class="flex flex-column pb-4">
                  <label class="text-sm text-color-secondary" for="productSoldDate"> Date de vente</label>
                  <p-calendar formControlName="productSoldDate" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
                  <div class="flex items-center gap-1 pt-2">
                    <p-checkbox checked formControlName="productStatus" binary="true" inputId="ips" />
                    <label for="ips" class="ml-2">Le produit est vendu</label>
                  </div>

                  <!--Message d'erreur-->
                  <div class="min-h-0">
                    <ng-container *ngIf="updateProductFg.get('productSoldDate')?.invalid && (updateProductFg.get('productSoldDate')?.dirty || updateProductFg.get('productSoldDate')?.touched)">

                      <!-- Format erroné -->
                      <p-message *ngIf="updateProductFg.get('productSoldDate')?.hasError('validateNumber')"
                        class="p-message" severity="error" text="Le prix d'achat à un format invalide">
                      </p-message>
                    </ng-container>
                  </div>
                </div>
              </div>

              <!--Boutton-->
              <div class="flex flex-column w-full
                          md:flex-row">
                <p-button (onClick)="updateProduct()"  type="submit" severity="success" class="full--width--button m-1" label="Mettre à jour"/>
                <p-button (onClick)="desactivateProduct()" variant="outlined"  type="button" severity="danger" class="full--width--button m-1" label="Désactiver le produit"/>
              </div>
            </form>
          </ng-template>
        </main>
        <footer></footer>
      </article>
    </div>
  </ng-container>
</ng-container>
